import { useEffect, useRef } from "react";
import * as React from "react";
import Box from "@mui/material/Box";
import TitleIcon from "@mui/icons-material/Title";
import { Control, Controller, FieldErrors } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { AppointmentFormValues } from "../appointment-form.component";

type TitleFieldProps = {
  control: Control<AppointmentFormValues, object>;
  autoFocus?: boolean;
  errors: FieldErrors<AppointmentFormValues>;
};

export default function TitleField({
  control,
  autoFocus = true,
  errors,
}: TitleFieldProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    autoFocus && inputRef.current?.focus();
  }, [autoFocus]);
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <TitleIcon sx={{ mt: 0.5, mr: 1.5 }} />
      <Controller
        name="title"
        control={control}
        rules={{ required: "Title is required" }}
        render={({ field }) => (
          <TextField
            required
            fullWidth
            placeholder="Add title *"
            {...(Boolean(errors?.title?.message)
              ? { error: true, helperText: errors?.title?.message }
              : {})}
            {...field}
            inputRef={inputRef}
          />
        )}
      />
    </Box>
  );
}
